var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileCof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1735 64H13.8265C6.18922 64 0 57.8081 0 50.1735V13.8265C0 6.19191 6.19191 0 13.8265 0H50.1735C57.8108 0 64 6.19191 64 13.8265V50.1735C64 57.8108 57.8108 64 50.1735 64Z",
    fill: "#40C872"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8058 37.1321C16.3685 37.1321 15.1591 36.6413 14.1776 35.6626C13.2283 34.6811 12.7375 33.4717 12.7375 31.9994C12.7375 30.5272 13.2283 29.3178 14.1776 28.3363C15.1591 27.3548 16.3685 26.8641 17.8058 26.8641C18.8651 26.8641 19.809 27.1403 20.5706 27.6418C20.8844 26.494 21.3188 25.3999 21.8632 24.3648C20.6725 23.7453 19.2941 23.3994 17.8407 23.3994C15.387 23.3994 13.3275 24.2173 11.6622 25.8853C10.0264 27.5184 9.2085 29.5457 9.2085 31.9994C9.2085 34.4183 10.0264 36.4456 11.6622 38.1136C13.3275 39.7815 15.3897 40.5994 17.8407 40.5994C19.2968 40.5994 20.6671 40.2562 21.8605 39.6287C21.3161 38.5963 20.8817 37.4995 20.5679 36.3517C19.7902 36.8505 18.8383 37.1321 17.8058 37.1321Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3017 48.492C29.2082 48.492 21.8096 41.0933 21.8096 31.9999C21.8096 22.9065 29.2082 15.5078 38.3017 15.5078C47.3951 15.5078 54.7937 22.9065 54.7937 31.9999C54.7937 41.0933 47.3951 48.492 38.3017 48.492ZM38.3017 19.3881C31.3455 19.3881 25.6899 25.0464 25.6899 31.9999C25.6899 38.9534 31.3482 44.6116 38.3017 44.6116C45.2551 44.6116 50.9134 38.9534 50.9134 31.9999C50.9134 25.0464 45.2578 19.3881 38.3017 19.3881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCof);
export default __webpack_public_path__ + "static/media/mobile-cof.dd98c5ca739300e1be9cd75f9f7230bb.svg";
export { ForwardRef as ReactComponent };